module.exports = __webpack_public_path__ + "static/img/phone_ico_qrcode.6a20bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business_cooperation/phone_ico_qrcode.png
// module id = t0rj
// module chunks = 0